"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var BrandValidationService = /** @class */ (function () {
    function BrandValidationService() {
        this.schemaForGetBrands = joi_1.default.object().keys({
            page: joi_1.default.number().optional(),
            brandId: joi_1.default.number().optional()
        });
        this.schemaForGetBrandBySlug = joi_1.default.object().keys({
            slug: joi_1.default.string().required()
        });
    }
    BrandValidationService.prototype.getBrandsData = function (data) {
        var error = this.schemaForGetBrands.validate(data).error;
        // debug
        console.debug('Validating get brands data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    BrandValidationService.prototype.getBrandBySlugData = function (data) {
        var error = this.schemaForGetBrandBySlug.validate(data).error;
        // debug
        console.debug('Validating get brand by slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return BrandValidationService;
}());
exports.BrandValidationService = BrandValidationService;
//# sourceMappingURL=BrandValidationService.js.map